/* Magazine issue articles carousel controls for all breakpoints. */
(function () {
  function initSlider(component) {
    if (!component || component.dataset.magIssueCarouselInitialized === 'true') return;

    var slider = component.querySelector('.mag-issue-carousel__slider');
    var nav = component.querySelector('[data-mag-issue-carousel-nav]');
    var prevButton = component.querySelector('.mag-issue-carousel__orbit--prev');
    var nextButton = component.querySelector('.mag-issue-carousel__orbit--next');
    var slides = Array.prototype.slice.call(component.querySelectorAll('.mag-issue-carousel__slide'));
    var dots = Array.prototype.slice.call(component.querySelectorAll('.mag-issue-carousel__dot'));
    var dotLabelTemplate = nav ? nav.dataset.magIssueCarouselLabelTemplate : '';
    var frame;

    if (!slider || !nav || slides.length < 2 || dots.length !== slides.length) return;
    component.dataset.magIssueCarouselInitialized = 'true';

    function maxScroll() {
      return Math.max(0, slider.scrollWidth - slider.clientWidth);
    }

    function slidePosition(slide) {
      return slide.getBoundingClientRect().left - slider.getBoundingClientRect().left + slider.scrollLeft;
    }

    function scrollStops() {
      var scrollLimit = maxScroll();

      return slides.reduce(function (stops, slide) {
        var position = Math.max(0, Math.min(slidePosition(slide), scrollLimit));
        var previous = stops[stops.length - 1];

        if (!previous) {
          stops.push({ position: position });
          return stops;
        }

        if (Math.abs(previous.position - position) <= 2) return stops;

        // Merge a very short final movement into the previous step instead of
        // exposing an extra dot that only shifts the track by a few pixels.
        if (scrollLimit - position <= 2 && position - previous.position < slide.clientWidth * 0.25) {
          previous.position = position;
          return stops;
        }

        stops.push({ position: position });
        return stops;
      }, []);
    }

    function currentIndex(stops) {
      if (!stops.length) return 0;

      var closestIndex = 0;
      var closestDistance = Infinity;
      stops.forEach(function (stop, index) {
        var distance = Math.abs(stop.position - slider.scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });
      return closestIndex;
    }

    function update() {
      var stops = scrollStops();
      var active = maxScroll() > 1 && stops.length > 1;
      var index = currentIndex(stops);

      nav.hidden = !active;

      dots.forEach(function (dot, dotIndex) {
        var isAvailable = active && dotIndex < stops.length;
        var isActive = isAvailable && dotIndex === index;

        dot.hidden = !isAvailable;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');

        if (isAvailable && dotLabelTemplate) {
          dot.setAttribute(
            'aria-label',
            dotLabelTemplate.replace('__INDEX__', dotIndex + 1).replace('__TOTAL__', stops.length)
          );
        }
      });

      if (prevButton) prevButton.disabled = !active || index === 0;
      if (nextButton) nextButton.disabled = !active || index === stops.length - 1;
    }

    function goTo(index) {
      var stops = scrollStops();
      if (!stops.length) return;

      var boundedIndex = Math.max(0, Math.min(stops.length - 1, index));
      slider.scrollTo({ left: stops[boundedIndex].position, behavior: 'smooth' });
    }

    function overrideArrow(button, direction) {
      if (!button) return;

      button.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          goTo(currentIndex(scrollStops()) + direction);
        },
        true
      );
    }

    overrideArrow(prevButton, -1);
    overrideArrow(nextButton, 1);

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        goTo(index);
      });
    });

    slider.addEventListener('scroll', function () {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(slider);
    } else {
      window.addEventListener('resize', update);
    }

    update();
  }

  function init(scope) {
    if (!scope) return;
    if (scope.matches && scope.matches('.mag-issue-carousel__component')) initSlider(scope);
    scope.querySelectorAll('.mag-issue-carousel__component').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
